import AnnualInspection from './AnnualInspection.vue'

export default AnnualInspection



// WEBPACK FOOTER //
// ./src/pages/AnnualInspection/index.js